// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__X7wMo","approved":"Status_approved__r91vm","rejected":"Status_rejected__3v_d9","expired":"Status_expired__2rVxg","label":"Status_label__zHkt3"};